import React from 'react';
import { Link } from 'react-router-dom';
import { Code, Menu, X } from 'lucide-react';

const Header = ({ activeSection, isMenuOpen, isScrolled, setIsMenuOpen, scrollToSection, openBlogs }) => {
  const navItems = [
    'home',
    'about',
    'services',
    'industries',
    'projects',
    'careers',
    'contact'
  ];

  return (
    <header className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-slate-900/95 backdrop-blur-md shadow-lg' : 'bg-transparent'}`}>
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-2">
            <div className="w-10 h-10 bg-gradient-to-r from-cyan-400 to-blue-500 rounded-lg flex items-center justify-center">
              <Code className="w-6 h-6 text-white" />
            </div>
            <span className="text-2xl font-bold text-white">Algoryn</span>
          </Link>
          
          <nav className="hidden md:flex space-x-8">
            {navItems.map((item) => (
              <button
                key={item}
                onClick={() => scrollToSection(item)}
                className={`capitalize transition-colors duration-200 ${
                  activeSection === item ? 'text-cyan-400' : 'text-white hover:text-cyan-400'
                }`}
              >
                {item === 'industries' ? 'Industries' : item}
              </button>
            ))}
            <button
              onClick={openBlogs}
              className={`transition-colors duration-200 ${
                activeSection === 'blogs' ? 'text-cyan-400' : 'text-white hover:text-cyan-400'
              }`}
            >
              Blogs
            </button>
          </nav>
          
          <button
            className="md:hidden text-white"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
        
        {isMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 border-t border-slate-700">
            {navItems.map((item) => (
              <button
                key={item}
                onClick={() => scrollToSection(item)}
                className="block w-full text-left py-2 capitalize text-white hover:text-cyan-400 transition-colors"
              >
                {item === 'industries' ? 'Industries' : item}
              </button>
            ))}
            <button
              onClick={openBlogs}
              className="block w-full text-left py-2 text-white hover:text-cyan-400 transition-colors"
            >
              Blogs
            </button>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
